import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../../core/auth/services/auth.service';
import { BmiDetailsService } from '../../services/bmi-details.service';
import { BMIHistoryResponse } from '../../bmi-const/bmi-details-models';
import { BmiCardComponent } from "../../../dashboard/components/bmi-card/bmi-card.component";
import { BmiGraphComponent } from '../bmi-graph/bmi-graph.component';
import { BmiHistoryListComponent } from '../bmi-history-list/bmi-history-list.component';

@Component({
  selector: 'patient-bmi-details',
  standalone: true,
  imports: [CommonModule, BmiCardComponent, BmiGraphComponent, BmiHistoryListComponent],
  templateUrl: './bmi-details.component.html',
  styleUrl: './bmi-details.component.css',
})
export class BmiDetailsComponent implements OnInit {
  patientId!: string;
  bmiHistoryData: BMIHistoryResponse | null = null;
  loading: boolean = true;

  private authService = inject(AuthService);
  private bmiDetailsService = inject(BmiDetailsService);

  constructor() {}

  ngOnInit(): void {
    this.authService.getUserProfile().subscribe((res) => {
      if (res?.PatientId) {
        this.patientId = res.PatientId;
        this.fetchBmiHistoryData();
      }
    });
  }

  fetchBmiHistoryData() {
    this.loading = true;
    this.bmiDetailsService.getBMIHistory(this.patientId).subscribe({
      next: (response) => {
        if (response && response.status === 200) {
          this.bmiHistoryData = response;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load BMI details:', err);
        this.loading = false;
      }
    });
  }
}
